import { PencilIcon } from "@heroicons/react/24/solid";
import { useRouter } from "next/router";
import { FaAngleDoubleUp } from "react-icons/fa";
import { Vehicle } from "../graphql/generated/graphql";
import { classNames } from "../utils/formatters";

export default function PromoteVehicleButton({
  loading,
  asIcon,
  data,
}: {
  loading?: boolean;
  asIcon?: boolean;
  data: Vehicle;
}) {
  const router = useRouter();

  function goToPromote(e) {
    e.stopPropagation();
    const pathname = `/destacar/${data._id}`;
    router.push(
      {
        pathname,
      },
      pathname
    );
  }

  if (asIcon) {
    return (
      <PencilIcon
        className={classNames(
          "  h-6 w-6 p-0.5 z-10 text-gray-500 rounded-full ",
          " hover:text-orange-500",
          loading ? "opacity-70" : ""
        )}
        aria-hidden="true"
        onClick={goToPromote}
      />
    );
  }

  return (
    <button
      disabled={loading}
      className="-ml-px relative inline-flex items-center space-x-2 rounded-md border-2 border-blue-500 bg-blue-500 px-3 sm:px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-600 hover:border-blue-600 disabled:opacity-70"
      onClick={goToPromote}
    >
      <FaAngleDoubleUp className="h-5 w-5 animate-bounce" />
      {/* <PencilIcon className="h-5 w-5" aria-hidden="true" /> */}
      <span className="hidden sm:inline">Destacar</span>
    </button>
  );
}
